import { StateSchema } from 'app/providers/StoreProvider';

export const getShopProducts = (state: StateSchema) => state.services.products;
export const getSpecialProducts = (state: StateSchema) => state.services.specialProducts;
export const getProductsInfo = (state: StateSchema) => state.services.productsInfo;
